import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { CreditSummaryModel } from '../../cmg-1003/models/credit-summary.model';
import { Cmg1003CreditSummaryStore } from './credit-summary.store';

@Injectable({ providedIn: 'root' })
export class Cmg1003CreditSummaryQuery extends Query<CreditSummaryModel> {
  protected store: Cmg1003CreditSummaryStore;

  dirtyChecker = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(Cmg1003CreditSummaryStore);

    super(store);

    this.store = store;
  }
}
